import { render, staticRenderFns } from "./CardsManager.vue?vue&type=template&id=1ed54935&scoped=true"
import script from "./CardsManager.vue?vue&type=script&lang=js"
export * from "./CardsManager.vue?vue&type=script&lang=js"
import style0 from "./CardsManager.vue?vue&type=style&index=0&id=1ed54935&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed54935",
  null
  
)

export default component.exports